import React from 'react'
import { Badge } from '../common/badge/Badge'
import { tokens } from '@fluentui/react-components'

type BadgeComplianceLevelProps = {
   bgHexColor: string
   text: string
   className?: string
}

export const BadgeComplianceLevel = ({ text, bgHexColor, className }: BadgeComplianceLevelProps) => {
   return (
      <Badge
         appearance="filled"
         shape="rounded"
         style={{
            color: tokens.colorNeutralForegroundInverted,
            backgroundColor: bgHexColor ? `${bgHexColor}` : tokens.colorBrandBackground2,
            boxShadow: tokens.shadow8,
            minWidth: '120px',
            minHeight: '25px',
         }}
         className={className ?? ''}
      >
         {text.replace('kravefterlevnad', '')}
      </Badge>
   )
}
